import { connect, mapReadPretty, mapProps } from "@formily/react";
import { useTranslation } from "react-i18next";
import { Checkbox as CheckboxBase } from "../base/Checkbox";
import { isField } from "@formily/core";

function CheckboxReadPretty(props: { value?: unknown }) {
  const { t } = useTranslation(["common"]);
  return <>{props.value ? t(($) => $.common["Yes"]) : t(($) => $.common["No"])}</>;
}

export const Checkbox = connect(
  CheckboxBase,
  mapProps((props, field) => {
    if (!isField(field)) return props;

    return {
      ...props,
      label: field.title,
      value: field.value,
      isDisabled: props.isDisabled ?? field.disabled,
      onChange: (value) => {
        void field.onInput(value);
      },
    };
  }),
  mapReadPretty(CheckboxReadPretty),
);
